import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class NewsletterFooterService {
  private url = 'newsletter_footers';
  constructor(private httpClient: HttpClientService) {}

  searchOptions(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
  create(params: any = {}): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, params);
  }
  delete(params: any = {}): Promise<any> {
    console.log('delete params', params);
    return this.httpClient.delete(`${this.url}/${params.id}.json`);
  }
  show(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/${params.newsletterFooterId}.json`, params);
  }
  update(params: any = {}): Promise<any> {
    console.log('update params', params);
    return this.httpClient.put(`${this.url}/${params.newsletterFooterId}.json`, params);
  }
}
